module.exports = __webpack_public_path__ + "static/media/YM55_1.d19f0302.jpg";